import React from 'react';
import { AppBar, Toolbar, Box, Typography, Container, Button, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import { Link as ScrollLink } from 'react-scroll';

const Header: React.FC = () => {
  const theme = useTheme();

  return (
    <AppBar position="fixed" elevation={0} sx={{ 
      background: 'rgba(255, 255, 255, 0.9)',
      backdropFilter: 'blur(10px)',
      borderBottom: '1px solid rgba(0, 0, 0, 0.05)'
    }}>
      <Container>
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                variant="h5"
                noWrap
                component="div"
                sx={{
                  mr: 2,
                  fontWeight: 700,
                  color: theme.palette.primary.main,
                  textDecoration: 'none',
                }}
              >
                GameGuard AI
              </Typography>
            </Box>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <ScrollLink to="faq" smooth={true} duration={500}>
              <Button 
                variant="contained" 
                color="primary" 
                sx={{ 
                  fontWeight: 600,
                  px: 3,
                  py: 1
                }}
              >
                Начать
              </Button>
            </ScrollLink>
          </motion.div>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header; 